import * as Sentry from "@sentry/react";
import { useToastsContext } from "@lending/hooks/useToasts";
import { useApi } from "@lending/lib/api";
import type { StateEnum } from "@lending/types";

interface MembershipRequirementResponse {
  state: StateEnum;
  membership_share_verification_required: boolean;
  membership_share_email_conflict: boolean;
}

interface Props {
  onSuccess: (response: MembershipRequirementResponse) => Promise<void>;
  onError: () => void;
}

function useCheckCreditCardMembershipRequirementQuery({ onSuccess, onError }: Props) {
  const $api = useApi();
  const { showGenericErrorToast } = useToastsContext();

  return $api.useMutation(
    "post",
    "/v2/lending/credit_card_applications/{uuid}/check_membership_requirement/",
    {
      onSuccess: async (data: MembershipRequirementResponse) => {
        await onSuccess({
          state: data.state,
          membership_share_verification_required: data.membership_share_verification_required,
          membership_share_email_conflict: data.membership_share_email_conflict,
        });
      },
      onError: (error) => {
        showGenericErrorToast();
        Sentry.captureException(error);
        onError();
      },
    }
  );
}

export { useCheckCreditCardMembershipRequirementQuery };
